/* Creed Fashion: gumb "Obvesti me, ko bo spet na zalogi" in okno z obrazcem
   (okno izriše sections/creed-bis-form.liquid). 12. 10. 2026.
   Tema razprodane velikosti ne pusti izbrati (siva pilula brez učinka), zato:
   - gumb je viden, kadar ima izdelek vsaj eno razprodano varianto,
   - v oknu kupec izbere velikost med razprodanimi (pilule), predizbrana je tista v trenutni barvi,
   - klik na sivo (razprodano) velikost na strani izdelka odpre okno kar s to velikostjo. */
(function () {
  'use strict';
  if (window.Shopify && Shopify.designMode) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var ov = document.getElementById('creed-bis-ov');
    var box = document.getElementById('creed-bis');
    if (!ov || !box) return;

    var variants = {};
    try { variants = JSON.parse(ov.getAttribute('data-variants') || '{}'); } catch (e) {}
    var soldIds = Object.keys(variants).filter(function (id) { return variants[id].a === false; });
    var btnText = ov.getAttribute('data-btn') || 'OBVESTI ME';
    var sizeLabel = ov.getAttribute('data-size-label') || 'Velikost';

    var fVariant = document.getElementById('creed-bis-variant');
    var fSize = document.getElementById('creed-bis-size');
    var fBody = document.getElementById('creed-bis-body');
    var fNewsVal = document.getElementById('creed-bis-news-val');
    var cbNews = document.getElementById('creed-bis-news');
    var pSize = document.getElementById('creed-bis-psize');
    var sizesWrap = document.getElementById('creed-bis-sizes');
    var email = box.querySelector('input[type=email]');
    var submit = box.querySelector('.creed-bis__submit');

    function open() { ov.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { ov.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

    var x = box.querySelector('.creed-bis__x');
    if (x) x.addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('is-open')) close(); });

    if (cbNews && fNewsVal) {
      cbNews.addEventListener('change', function () { fNewsVal.value = cbNews.checked ? 'da' : 'ne'; });
    }

    /* po uspesni oddaji: zahvala je ze izrisana (Liquid), odpremo okno in pocistimo URL */
    if (box.getAttribute('data-posted') === 'true') {
      open();
      try {
        var q = window.location.search.replace(/[?&]contact_posted=true/, '').replace(/^&/, '?');
        history.replaceState({}, '', window.location.pathname + q);
      } catch (e) {}
      var su = document.getElementById('creed-su');
      if (su) { su.hidden = true; su.classList.remove('is-open'); }
      setTimeout(close, 9000);
      return;
    }
    if (box.getAttribute('data-error') === 'true') open();
    if (!soldIds.length) return;

    /* ---- glavni obrazec izdelka (brez lepljivega) ---- */
    function mainForm() {
      var forms = document.querySelectorAll('form.main-product-form');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].classList.contains('form-sticky-add-cart')) return forms[i];
      }
      return null;
    }
    function currentVariantId() {
      var f = mainForm();
      var inp = f && f.querySelector('input.product-variant-id');
      var id = inp && inp.value;
      if (!id) { var m = /[?&]variant=(\d+)/.exec(window.location.search); id = m ? m[1] : ''; }
      return id || '';
    }
    function parts(t) { return String(t || '').split(' / '); }

    /* ---- izbira velikosti v oknu ---- */
    var chosen = '';
    function select(id) {
      chosen = id;
      var v = variants[id] || {};
      var title = v.t && v.t !== 'Default Title' ? v.t : '';
      if (fVariant) fVariant.value = id;
      if (fSize) fSize.value = title;
      if (fBody) fBody.value = 'OBVESTI-ZALOGA | ' + ov.getAttribute('data-product-title') + (title ? ' | ' + title : '') + ' | varianta ' + id + ' | izdelek ' + ov.getAttribute('data-product-id');
      if (pSize) pSize.textContent = title ? sizeLabel + ': ' + title : '';
      if (sizesWrap) {
        Array.prototype.forEach.call(sizesWrap.children, function (p) { p.classList.toggle('is-sel', p.getAttribute('data-id') === id); });
      }
      if (submit) submit.disabled = !id;
    }
    function buildPills() {
      if (!sizesWrap || sizesWrap.children.length) return;
      soldIds.forEach(function (id) {
        var p = document.createElement('button');
        p.type = 'button';
        p.className = 'creed-bis__pill';
        p.setAttribute('data-id', id);
        p.textContent = variants[id].t;
        p.addEventListener('click', function () { select(id); });
        sizesWrap.appendChild(p);
      });
      if (soldIds.length === 1) sizesWrap.hidden = true;
    }
    /* razprodana varianta v isti barvi kot trenutno izbrana, sicer prva razprodana */
    function defaultSold() {
      var cur = variants[currentVariantId()];
      if (cur) {
        var cp = parts(cur.t);
        for (var i = 0; i < soldIds.length; i++) {
          var sp = parts(variants[soldIds[i]].t);
          if (sp.length === cp.length && sp.length > 1 && sp[0] === cp[0]) return soldIds[i];
        }
      }
      return soldIds[0];
    }
    function openWith(id) {
      buildPills();
      select(id || defaultSold());
      open();
      if (email) setTimeout(function () { try { email.focus(); } catch (e) {} }, 50);
    }

    /* ---- gumb pod "Dodaj v kosarico" ---- */
    var bisBtn = null;
    function ensureBtn(f) {
      if (bisBtn && document.body.contains(bisBtn)) return bisBtn;
      var host = f.querySelector('.product__submit-form-cart');
      if (!host) return null;
      bisBtn = document.createElement('button');
      bisBtn.type = 'button';
      bisBtn.className = 'creed-bis-btn is-on';
      bisBtn.id = 'creed-bis-btn';
      bisBtn.textContent = btnText;
      host.parentNode.insertBefore(bisBtn, host.nextSibling);
      bisBtn.addEventListener('click', function () { openWith(''); });
      return bisBtn;
    }
    function refresh() { var f = mainForm(); if (f) ensureBtn(f); }
    refresh();
    setInterval(refresh, 1000);

    /* ---- klik na sivo (razprodano) velikost odpre okno s to velikostjo ---- */
    document.addEventListener('click', function (e) {
      var lab = e.target && e.target.closest ? e.target.closest('label.text-swatch-label.disable, label.disable') : null;
      if (!lab) return;
      var fs = lab.closest('fieldset');
      var vi = lab.closest('variant-input');
      if (!fs || !vi) return;
      var idx = Array.prototype.indexOf.call(vi.querySelectorAll('fieldset'), fs);
      var txt = (lab.textContent || '').trim();
      var cur = variants[currentVariantId()];
      var want = cur ? parts(cur.t) : [];
      if (idx < 0 || idx >= want.length) return;
      want[idx] = txt;
      var key = want.join(' / ');
      var hit = soldIds.filter(function (id) { return variants[id].t === key; })[0];
      if (!hit) hit = soldIds.filter(function (id) { return parts(variants[id].t)[idx] === txt; })[0];
      if (!hit) return;
      e.preventDefault();
      openWith(hit);
    }, true);
  });
})();